import React from 'react';
import { useTranslation } from '../../context/LanguageContext';
import './DataVerification.css';

/* 관리자 > 데이터 확인 탭. 아직 연결된 API 가 없어 안내 문구만 보여 준다.
 * (예전 화면에 있던 예시 회사·설비 기록과 필터·통계 코드는 화면에 쓰이지 않아 지웠다 — 2026-10-02) */
function DataVerification() {
  const { t } = useTranslation();

  return (
    <div className="data-verification-container">
      <p>{t('pages.admin.dataVerification.placeholder')}</p>
    </div>
  );
}

export default DataVerification;
